var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "my-container" } },
    [
      _c(
        "div",
        {
          staticStyle: { border: "transparent", display: "flex" },
          attrs: { id: "popover-reactive-1" },
        },
        [
          _c("img", {
            attrs: {
              height: "40px",
              width: "40px",
              src: require("@Shared/@Assets/img/chat-bot-icon.png"),
              alt: _vm.$t("global.words.proChat"),
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "popover",
          attrs: {
            id: "my-popover",
            target: "popover-reactive-1",
            triggers: "click",
            container: "my-container",
            show: _vm.popoverShow,
            placement: _vm.isMobile ? "top" : "righttop",
            "boundary-padding": "1",
            "custom-class": "ma-0 pa-0",
          },
          on: {
            "update:show": function ($event) {
              _vm.popoverShow = $event
            },
          },
        },
        [
          _c("div", { attrs: { id: "chat-bot-container" } }, [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end pb-2" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "px-4 py-1 shadow-sm",
                    attrs: { pill: "", variant: "gray" },
                    on: { click: _vm.onClose },
                  },
                  [_vm._v("\n          X\n        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "shadow-lg rounded d-flex flex-column w-100 justify-content-end",
                staticStyle: { "background-color": "#f4f5f7" },
                attrs: { id: "main-container1" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-start rounded shadow-sm py-3 pl-2",
                    staticStyle: { "background-color": "#694ed6" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "mr-2 align-items-center justify-content-center",
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@Shared/@Assets/img/chat-bot-icon.png"),
                            alt: _vm.$t("global.words.proChat"),
                            height: "40px",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "align-items-center justify-content-center",
                      },
                      [
                        _c(
                          "h5",
                          { staticStyle: { color: "white", margin: "0" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("global.words.proChat")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "messageContainer",
                    staticClass:
                      "py-2 px-2 d-flex-column align-items-start justify-content-between",
                    attrs: { id: "chat-bot-body" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "p-2", staticStyle: { color: "gray" } },
                      [
                        _c("span", [
                          _vm._v(
                            "     " +
                              _vm._s(
                                _vm.$t("global.phrases.aiLegalDisclaimer")
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.messages, function (message, index) {
                      return _c("chat-message", {
                        key: index,
                        attrs: { message: message, index: index },
                        on: { msgstatus: _vm.vote },
                      })
                    }),
                    _vm._v(" "),
                    _vm.loading
                      ? _c("chat-message", { attrs: { loading: true } })
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "shadow-sm px-2 d-flex align-items-center justify-content-between rounded",
                    staticStyle: {
                      "align-self": "center",
                      "background-color": "white",
                      width: "100%",
                    },
                    attrs: { id: "chat-bot-footer" },
                  },
                  [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: _vm.$t("global.words.startNewChat"),
                            expression: "$t('global.words.startNewChat')",
                          },
                        ],
                        staticClass:
                          "d-flex align-items-center no-margin-padding chat-button",
                        on: { click: _vm.clearChat },
                      },
                      [
                        _c("img", {
                          attrs: {
                            height: "30px",
                            width: "30px",
                            src: require("@Shared/@Assets/img/clear-chat.png"),
                            alt: _vm.$t("global.words.proChat"),
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-grow-1 align-items-center align-self-stretch no-margin-padding chat-button",
                        attrs: { cols: "9" },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentMessage,
                              expression: "currentMessage",
                            },
                          ],
                          staticClass: "form-control form-control-lg",
                          staticStyle: { border: "0px" },
                          attrs: { type: "text", placeholder: "Message ..." },
                          domProps: { value: _vm.currentMessage },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleSendMessage.apply(
                                null,
                                arguments
                              )
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.currentMessage = $event.target.value
                            },
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: _vm.$t("global.words.submit"),
                            expression: "$t('global.words.submit')",
                          },
                        ],
                        staticClass:
                          "d-flex justify-content-center align-items-center no-margin-padding chat-button",
                        on: { click: _vm.handleSendMessage },
                      },
                      [
                        _c("img", {
                          attrs: {
                            height: "20px",
                            width: "20px",
                            src: require("@Shared/@Assets/img/send-message.png"),
                            alt: _vm.$t("global.words.proChat"),
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }